'use strict';
var request = require('../util/request');
import * as BitrateUtil from './bitrateutil';
import * as UrlUtil from '../util/url';
import * as VideoUtil from '../util/video-attributes';

// This code originates from https://github.com/videojs/videojs-contrib-hls
function parseRepresentation(m3u8) {
    var attributeSeparator = (function () {
        var key = '[^=]*';
        var value = '"[^"]*"|[^,]*';
        var keyvalue = '(?:' + key + ')=(?:' + value + ')';

        return new RegExp('(?:^|,)(' + keyvalue + ')');
    })();

    var parseAttributes = function (attributes) {
        var attrs = attributes.split(attributeSeparator);
        var i = attrs.length;
        var result = {};
        var attr;
        while (i--) {
            if (attrs[i] === '') {
                continue;
            }
            attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1);
            attr[0] = attr[0].replace(/^\s+|\s+$/g, '');
            attr[1] = attr[1].replace(/^\s+|\s+$/g, '');
            attr[1] = attr[1].replace(/^['"](.*)['"]$/g, '$1');
            result[attr[0]] = attr[1];
        }

        return result;
    };

    var parseLine = function (line) {
        var match;
        var properties;

        line = line.replace(/^\s+|\s+$/g, '');
        line = line.replace('\r', '');

        match = (/^#EXT-X-STREAM-INF:?(.*)$/).exec(line);
        if (match) {
            properties = parseAttributes(match[1]);
            if (properties.RESOLUTION) {
                var split = properties.RESOLUTION.split('x');
                if (split[0]) {
                    properties.width = parseInt(split[0], 10);
                }
                if (split[1]) {
                    properties.height = parseInt(split[1], 10);
                }
            }
            if (properties.BANDWIDTH) {
                properties.bandwidth = parseInt(properties.BANDWIDTH, 10);
            }
        }

        return properties;
    };

    var representation = [];
    var lines = m3u8.split('\n');
    for (var i = 0; i < lines.length; i++) {
        var result = parseLine(lines[i]);
        if (result !== undefined) {
            representation.push(result);
        }
    }

    return representation;
}

function limitVariantStreams(variants, videoElement, videoConfig) {
    const limitByMaxBitrateRule = (variants) => {
        const maxBitrate = VideoUtil.getMaxBitrate(videoElement);
        if (!maxBitrate) {
            return variants;
        }

        return BitrateUtil.limitVariantStreamsByMaxConstant(variants, maxBitrate * 1000);
    };

    const limitByPortalRule = (variants) =>
        BitrateUtil.limitVariantStreamsByPortal(
            variants, videoElement, true
        );

    // Used as a nop
    const identity = (variants) => variants;

    // Define rules that will limit the variants.
    const rules = [
        limitByMaxBitrateRule,
        videoConfig.limitBitrateByPortal ? limitByPortalRule : identity
    ];

    // Reduce by each rule.
    return rules.reduce((variants, rule) => rule(variants), variants);
}

function isValidResponseURL(responseURL) {
    return responseURL && responseURL.startsWith('http');
}

/**
 * Get manifest from URL. The manifest will also include the response URL from redirects.
 *
 * @param {String} url
 * @returns {Promise}
 */
export function getManifest(url) {
    return new Promise((resolve, reject) => {
        request.getText(url,
            (response, xhr) => {
                return resolve({
                    url: isValidResponseURL(xhr.responseURL) ? xhr.responseURL : url,
                    representation: parseRepresentation(response)
                });
            },
            (error) => {
                reject(error);
            });
    });
}

export function setupMaxBitrate(manifest, videoElement, videoConfig) {
    // Assume preferred starting bitrate is the first variant stream.
    const preferredStartBitrate = Math.ceil(manifest.representation[0].bandwidth / 1000);

    // Filter the variants by defined rules.
    const allowedVariants = limitVariantStreams(manifest.representation, videoElement, videoConfig);

    const maxAllowedBitrate = Math.ceil(
        Math.max.apply(null, allowedVariants.map((item) => item.bandwidth)) / 1000
    );

    const startBitrate = Math.min(
        preferredStartBitrate,
        maxAllowedBitrate
    );

    return UrlUtil.setQueryParameters({
        __b__: startBitrate,
        b: '0-' + maxAllowedBitrate
    }, manifest.url);
}



// WEBPACK FOOTER //
// ./src/js/modules/m3u8util.js